import { render, staticRenderFns } from "./PastEditions.vue?vue&type=template&id=54d0e4db&scoped=true&"
import script from "./PastEditions.vue?vue&type=script&lang=js&"
export * from "./PastEditions.vue?vue&type=script&lang=js&"
import style0 from "./PastEditions.vue?vue&type=style&index=0&id=54d0e4db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0e4db",
  null
  
)

export default component.exports